import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Layout from 'antd/lib/layout/layout';
import Text from 'antd/lib/typography/Text';
import Link from 'antd/lib/typography/Link';
import Card from 'antd/lib/card';
import Button from 'antd/lib/button';
import { RootState } from '../reducers/reducers';
import { tryLogout, TRY_LOGOUT } from '../actions/login';
import { getError, getIsLoading } from '../helpers';
import { antGrey } from './styles/globalStyles';
import { globalMessage } from '../utils/globalMessage';

const PaywallPage = () => {
    const logoutIsLoading = useSelector((state: RootState) => getIsLoading(TRY_LOGOUT, state));
    const logoutError = useSelector((state: RootState) => getError(TRY_LOGOUT, state));
    const dispatch = useDispatch();

    const logout = () => {
        dispatch(tryLogout());
    };

    React.useEffect(() => {
        if (logoutError) {
            globalMessage.error(logoutError);
        }
    }, [logoutError]);

    return (
        <Layout
            style={{
                display: 'flex',
                alignItems: 'center',
                textAlign: 'center',
                backgroundColor: antGrey.grey2,
            }}
        >
            <Card
                style={{
                    minWidth: '500px',
                    width: '60%',
                    maxWidth: '800px',
                    padding: '30px',
                    fontSize: '16px',
                    marginTop: 'auto',
                }}
            >
                <Text style={{ display: 'inline-block' }}>
                    Your trial has expired! We&apos;d love to keep helping you and your team streamline your releases,
                    so get in touch and we can get you set up with a subscription.
                </Text>
                <Link href="mailto:hello@runway.team">hello@runway.team</Link>
            </Card>
            <div style={{ marginTop: 'auto', marginBottom: '50px' }}>
                <Button onClick={logout} loading={logoutIsLoading}>
                    Log out
                </Button>
            </div>
        </Layout>
    );
};

export default PaywallPage;
